export const ASPECTS = [
  { key: "original", label: "Original shape (no crop)", ratio: null },
  { key: "square", label: "Square 1:1", ratio: "1 / 1" },
  { key: "portrait", label: "Portrait 3:4", ratio: "3 / 4" },
  { key: "tall", label: "Tall 2:3", ratio: "2 / 3" },
  { key: "scroll", label: "Scroll 1:2", ratio: "1 / 2" },
  { key: "landscape", label: "Landscape 4:3", ratio: "4 / 3" },
  { key: "classic", label: "Classic 3:2", ratio: "3 / 2" },
  { key: "wide", label: "Wide 16:9", ratio: "16 / 9" },
  { key: "panorama", label: "Banner 3:1", ratio: "3 / 1" },
];

export const ratioOf = (key, fallback = "landscape") =>
  (ASPECTS.find((a) => a.key === (key || fallback)) || ASPECTS.find((a) => a.key === fallback)).ratio;

export const isTall = (key) => ["portrait", "tall", "scroll"].includes(key);
